export default {
	mobileWidth: 800,
	tabletWidth: 1024,
}